module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/profile_page/skill-a6e7b07a51b1b7eaff00badfeb597757.png";